// extracted by mini-css-extract-plugin
export default {"tag":"Tags_tag__1or+H","lightColoredTag":"Tags_lightColoredTag__KKLHP"};